import React from 'react';

const UsersContext = React.createContext({
  users: []
});

export default UsersContext;